// Notifications REST API + helpers (role-aware link resolution).
import axios from 'axios';
import { API_URL } from '../../api/api';

const base = `${API_URL}/api/notifications`;

const auth = () => {
  const token = localStorage.getItem('token');
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

export const notificationsApi = {
  // GET /  → { notifications, unread }
  list: (params) => axios.get(base, { ...auth(), params }).then((r) => r.data),
  unreadCount: () => axios.get(`${base}/unread-count`, auth()).then((r) => r.data.unread),
  markRead: (id) => axios.put(`${base}/${id}/read`, {}, auth()).then((r) => r.data),
  markAllRead: () => axios.put(`${base}/read-all`, {}, auth()).then((r) => r.data),
};

// Current role's route base.
export const roleBase = () => {
  const r = localStorage.getItem('role');
  if (r === 'Admin') return '/admin';
  if (r === 'HR') return '/hr';
  return '/member';
};

// Notification links are stored role-relative (e.g. "/leaves"); resolve them
// against the current user's layout base. Already-absolute links pass through.
export const resolveNotifLink = (link) => {
  if (!link) return null;
  if (/^\/(admin|hr|member)(\/|$)/.test(link)) return link;
  return `${roleBase()}${link.startsWith('/') ? '' : '/'}${link}`;
};

// Notifications-page category filter. Keys must match CATEGORY_FILTERS in
// backend/models/notificationModel.js ('all' sends no filter).
export const NOTIF_CATEGORIES = [
  { key: 'all', label: 'All types' },
  { key: 'leaves', label: 'Leaves' },
  { key: 'attendance', label: 'Attendance' },
  { key: 'timesheets', label: 'Timesheets' },
  { key: 'shifts', label: 'Shifts' },
  { key: 'employees', label: 'Employees' },
  { key: 'notes', label: 'Notes' },
  { key: 'canvas', label: 'Canvas' },
  { key: 'celebrations', label: 'Celebrations' },
];

// Icon name + tint by notification type prefix (for the UI to map to lucide).
export const notifMeta = (type = '') => {
  if (type.startsWith('leave')) return { icon: 'plane', tone: '#2b7fff' };
  if (type.startsWith('regularisation')) return { icon: 'clock', tone: '#f54b01' };
  if (type.startsWith('attendance')) return { icon: 'clock', tone: '#f54b01' };
  if (type.startsWith('shift')) return { icon: 'alarm-clock', tone: '#8e51ff' };
  if (type.startsWith('timesheet')) return { icon: 'calendar-clock', tone: '#00a63e' };
  if (type.startsWith('employee')) return { icon: 'user', tone: '#0092b8' };
  if (type.startsWith('note')) return { icon: 'sticky-note', tone: '#d08700' };
  if (type.startsWith('canvas')) return { icon: 'pen-tool', tone: '#8e51ff' };
  if (type === 'birthday' || type === 'anniversary') return { icon: 'cake', tone: '#e60076' };
  return { icon: 'bell', tone: '#6a7282' };
};
